import React, { useState, useEffect } from 'react';
import '../CSS/CardSlider.css';

// Import images
import imgAvatar1 from '../Images/malaysia.jpg';
import imgAvatar2 from '../Images/bali.jpg';
import imgAvatar3 from '../Images/cambodia.jpg';
import imgAvatar4 from '../Images/Vietnam.jpg';
import imgAvatar5 from '../Images/thailand.jpg';
import imgAvatar6 from '../Images/singapore.jpg';
import imgAvatar7 from '../Images/dubai.jpg';
import imgAvatar8 from '../Images/azerbaijan.jpg';
import imgAvatar9 from '../Images/mysore.jpg';
import imgAvatar10 from '../Images/rishikesh.jpg';
import imgAvatar11 from '../Images/goa.jpg';
import imgAvatar12 from '../Images/manali.jpg';
import imgAvatar13 from '../Images/kerala.jpg';


const CardSlider = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [note, setNote] = useState("");

  // Packages
  const summerSpecialCards = [
    {
      name: 'Malaysia', role: '4 Nights', img: imgAvatar1, details: 'Experience the cultural blend of Malaysia.', description: `
    <strong>Package Cost Includes</strong><br>
    4 N Accommodation in @ 3 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Kuala Lumpur<br>
    Johor Bahru<br>
    Kota Kinabalu<br>
    Melaka<br>
    Airport Transport<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 69999 },
    { name: 'Bali', role: '5 Nights', img: imgAvatar2, details: 'Bali, Your Way Experience, Explore, Embrace.', description: `
    <strong>Package Cost Includes</strong><br>
    5 N Accommodation in @ 4 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Benoa Beach Water Sport Included 1 Round Banana Boat<br>
    Uluwatu Temple<br>
    Tegenungan waterfall Ubud Rice<br>
    Terrace Kintamani Coffee Plantation<br>
    Bedugul Ulundanu Tanah lot<br>
    Nusa Penida<br>
    Dinner<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 68555 },
    { name: 'Cambodia', role: '4 Nights', img: imgAvatar3, details: 'Cambodia: Kingdom of Wonder.', description: `
    <strong>Package Cost Includes</strong><br>
    4 N Accommodation in @ 4 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Siem Reap City Tour<br>
    Siem Reap Angkorwat<br>
    Phnom Penh City Tour<br>
    Airport Transport<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 85555 },
    { name: 'Vietnam', role: '4 Nights', img: imgAvatar4, details: 'Vietnam - Timeless Charm.', description: `
    <strong>Package Cost Includes</strong><br>
    4 N Accommodation in @ 3 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Hanoi City Tour<br>
    Explore Ninh Binh<br>
    Halong Bay Full Day Cruse<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 75999 },
  ];

  const popularTourCards = [
    { name: 'Thailand', role: '5 Nights', img: imgAvatar5, details: 'Visit Thailand’s stunning islands and culture.', description: `
    <strong>Package Cost Includes</strong><br>
    3 N Accommodation in Pattaya @ 3 Star Hotel<br>
    2 N Accommodation in Bangkok @ 3 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Coral Island Tour with Lunch<br>
    Pattaya City Tour with Temples<br>
    Pattaya Alcazar Show Ticket & Transfer<br>
    Safari World with Marine Park with Lunch<br>
    Return Flight Include<br>
    Dinner + Breakfast<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 55000 },
    { name: 'Singapore', role: '4 Nights', img: imgAvatar6, details: 'Explore modern Singapore with its stunning skyline.', description: `
    <strong>Package Cost Includes</strong><br>
    4 N Accommodation in @ 3 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Garden by The Bay<br>
    Universal Studio<br>
    Night Safari<br>
    Merlion Statue<br>
    Return Flight Include<br>
    Dinner<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 79999 },
    { name: 'Dubai', role: '4 Nights', img: imgAvatar7, details: 'Enjoy the tallest buildings and desert safaris.', description: `
    <strong>Package Cost Includes</strong><br>
    4 N Accommodation in @ 3 Star Hotel<br>
    Daily Breakfast at Hotel<br>
    Dhow Cruise Sharing Basis<br>
    Dhow Cruise Marina Sic<br>
    Haf Day Dubai City Tour Monrail Oneway Pass Gateway to atlantis<br>
    Dubai Mall, Burj Khalifa<br>
    Desert Safari<br>
    Abu dhabi City Tour, Baps Temple<br>
    Grand Mosque<br>
    Return Flight Include<br>
    Air Pickup Drop<br>
    Visa Included<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 68000 },
    { name: 'Azerbaijan', role: '9 Nights', img: imgAvatar8, details: 'Take Another Look.', description: `
    <strong>Package Cost Includes</strong><br>
    5 N Accommodation in @ 3 Star Hotel<br>
    4 N Baktu & 1 N in Sheki<br>
    Daily Breakfast at Hotel<br>
    All Major Sightseeing<br>
    Baku Old City tour<br>
    Nizami Street<br>
    Airport Transport<br>
    <em>(ALL TOURS & TRANSFER ON PVT BASIS)</em>
    `, price: 79000 },
  ];

  const domesticPackagesCards = [
    { name: 'Mysore', role: '3 Nights', img: imgAvatar9, details: 'Experience heritage and royalty in Mysore.' },
    { name: 'Rishikesh', role: '2 Nights', img: imgAvatar10, details: 'Yoga and river rafting in Rishikesh.' },
    { name: 'Goa', role: '4 Nights', img: imgAvatar11, details: 'Sun, sand, and parties in Goa.' },
    { name: 'Manali', role: '2 Nights', img: imgAvatar12, details: 'Scenic views and adventure in Manali.' },
    { name: 'Kerala', role: '4 Nights', img: imgAvatar13, details: 'Houseboats and backwaters in Kerala.' },

  ];

  return (
    <div className="container text-center">
      <Slider title="Summer Special Tour Package" cards={summerSpecialCards} setSelectedPackage={setSelectedPackage} />
      <Slider title="Popular Tour Package" cards={popularTourCards} setSelectedPackage={setSelectedPackage} />
      <Slider title="Domestic Packages" cards={domesticPackagesCards} setSelectedPackage={setSelectedPackage} />

      {/* Modal for Package Details */}
      {selectedPackage && (
        <div className="modal-overlay" onClick={() => setSelectedPackage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>

            {/* Left Image */}
            <img src={selectedPackage.img} alt={selectedPackage.name} />

            {/* Right details */}
            <div className="modal-details">
              <h2>{selectedPackage.name}</h2>

              {/* Short details */}
              <p>{selectedPackage.details}</p>

              {/* Full package description */}
              <p
                className="modal-description"
                dangerouslySetInnerHTML={{ __html: selectedPackage.description }}
              ></p>

              {/* Price badge */}
              <div className="price-tag">
                <span>₹ {selectedPackage.price}</span>
                <small> (per person)</small>
              </div>

              {/* Note box */}
              <div className="note-box">
                <label htmlFor="note">Add a note:</label>
                <textarea
                  id="note"
                  placeholder="Type your note here..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>

              {/* WhatsApp button */}
              <div className="modal-footer">
                <button
                  className="btn-whatsapp"
                  onClick={() => {
                    const message = encodeURIComponent(
                      `Hello, I am interested in the package "${selectedPackage.name}". Note: ${note}`
                    );
                    const phone = "+66925528900"; // replace with your number
                    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
                  }}
                >
                  <i className="bi bi-whatsapp"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

const Slider = ({ title, cards, setSelectedPackage }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlidesToShow = () => {
      setSlidesToShow(window.innerWidth <= 768 ? 1 : 3);
    };
    window.addEventListener('resize', updateSlidesToShow);
    updateSlidesToShow(); // Set initial value on mount

    return () => {
      window.removeEventListener('resize', updateSlidesToShow);
    };
  }, []);

  const nextSlide = () => {
    if (currentIndex < cards.length - slidesToShow) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };


  return (
    <div>
      <div className='p-5'></div>
      <h2>{title}</h2>
      <h6>We provide Domestic and International travel services with safety & accuracy. Visit us now!</h6>
      <hr />
      <br />
      <div className="slider-container">
        <button className="prev btn" onClick={prevSlide}>
          &#10094;
        </button>

        <div className="slider-wrapper">
          <div
            className="cards-wrapper"
            style={{
              transform: `translateX(-${currentIndex * (300 + 32)}px)` // 300 = card width, 32 = gap
            }}
          >
            {cards.map((card, index) => (
              <div className="card" key={index} onClick={() => setSelectedPackage(card)}>
                <img src={card.img} alt={card.name} />
                <div className="container text-center p-3">
                  <h4><b>{card.name}</b></h4>
                  <p>{card.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button className="next btn" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default CardSlider;